import React from 'react';
import PropTypes from 'prop-types';

/**
 * ServerPreload - Server-side resource preload declaration
 *
 * Declares any resource to preload in the <head> during server rendering.
 * Renders same hidden marker div on both server and client (no hydration mismatch).
 * Server: collectPreloads extracts markers and renders <link rel="preload"> tags
 * Client: Hidden div doesn't affect rendering, just sits in DOM
 *
 * Usage:
 * <ServerPreload href="/image.webp" as="image" media="(max-width: 768px)" crossOrigin="anonymous" />
 */
const ServerPreload = ({
	href,
	as = 'image',
	media,
	crossOrigin,
	imageSrcSet,
	imageSizes,
}) => {
	const attrs = {
		'data-preload-href': href,
		'data-preload-as': as,
		...(media && { 'data-preload-media': media }),
		...(crossOrigin && { 'data-preload-crossorigin': crossOrigin }),
		...(imageSrcSet && { 'data-preload-imagesrcset': imageSrcSet }),
		...(imageSizes && { 'data-preload-imagesizes': imageSizes }),
	};

	return React.createElement('div', {
		style: { display: 'none' },
		...attrs,
	});
};

ServerPreload.propTypes = {
	href: PropTypes.string.isRequired,
	as: PropTypes.string,
	media: PropTypes.string,
	crossOrigin: PropTypes.string,
	imageSrcSet: PropTypes.string,
	imageSizes: PropTypes.string,
};

export default ServerPreload;
